import React, { useState } from 'react';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_green.css';
import './dateRangePicker.css';
import { Calendar } from 'lucide-react';

const durationOptions = [
  { label: '1 Month', value: '1m' },
  { label: '3 Months', value: '3m' },
  { label: '6 Months', value: '6m' },
  { label: '9 Months', value: '9m' },
  { label: '1 Year', value: '1y' },
  { label: '2 Years', value: '2y' },
  { label: '3 Years', value: '3y' },
  { label: '5 Years', value: '5y' },
  { label: 'Custom', value: 'custom' },
];

const DateRangeSelector = (props) => {
  const [selectedRangeValue, setSelectedRangeValue] = useState('1y');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);

  const handleRangeSelection = (range) => {
    setSelectedRangeValue(range.value);
    if (range.value !== 'custom') {
      setStartDate(null);
      setEndDate(null);
      setStartDateError(false);
      setEndDateError(false);
      props.onRangeChange('month', range.value);
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(date[0]);
    // Clear error when date is selected
    if (date[0]) {
      setStartDateError(false);
    }
    props.onCustomDateChangeforStart({
      startDate: date[0],
      endDate: endDate,
      isStartDate: true,
      range: selectedRangeValue,
      pickerType: 'start'
    });
  };

  const handleEndDateChange = (date) => {
    setEndDate(date[0]);
    // Clear error when date is selected
    if (date[0]) {
      setEndDateError(false);
    }
    props.onCustomDateChangeforEnd({
      startDate: startDate,
      endDate: date[0],
      isStartDate: false,
      range: selectedRangeValue,
      pickerType: 'end'
    });
  };

  const handleSearchClick = () => {
    // Only validate when Custom is selected
    if (selectedRangeValue === 'custom') {
      const hasStartDateError = !startDate;
      const hasEndDateError = !endDate;
      
      setStartDateError(hasStartDateError);
      setEndDateError(hasEndDateError);
      
      // Only proceed if both dates are filled
      if (!hasStartDateError && !hasEndDateError) {
        props.onSearch({
          startDate,
          endDate,
          range: selectedRangeValue
        });
      }
    } else {
      // For non-custom ranges, proceed normally
      if (startDate && endDate) {
        props.onSearch({
          startDate,
          endDate,
          range: selectedRangeValue
        });
      }
    }
  };

  return (
    <div className="date-range-selector">
      <span className="date-range-label">Date Range Selection:</span>
      <div className="date-range-wrapper">
        <div className="radio-group">
          {durationOptions.map((range) => (
            <label key={range.value} className="radio-button">
              <input
                type="radio"
                name="duration"
                value={range.value}
                checked={range.value === selectedRangeValue}
                onChange={() => handleRangeSelection(range)}
                className="radio-input"
              />
              <span className="radio-label-text">{range.label}</span>
            </label>
          ))}
        </div>

        {selectedRangeValue === 'custom' && (
          <div className="custom-date-pickers">
            <div className="date-picker-container">
              <Flatpickr
                id="startDate"
                value={startDate}
                onChange={handleStartDateChange}
                options={{
                  maxDate: endDate || new Date(),
                  dateFormat: 'm/d/Y',
                }}
                placeholder="Start Date"
                className={`date-picker-input-trends ${startDateError ? 'date-input-error' : ''}`}
              />
              <div className="date-picker-button" onClick={() => document.querySelector("#startDate").focus()} >
                <Calendar size={14} />
              </div>
            </div>
            <div className="date-picker-container">
              <Flatpickr
                id="endDate"
                value={endDate}
                onChange={handleEndDateChange}
                options={{
                  maxDate: new Date(),
                  dateFormat: 'm/d/Y',
                }}
                placeholder="End Date"
                className={`date-picker-input-trends ${endDateError ? 'date-input-error' : ''}`}
              />
              <div className="date-picker-button"  onClick={() => document.querySelector("#endDate").focus()}>
                <Calendar size={14} />
              </div>
            </div>
            <button className="search-button" onClick={handleSearchClick}>Search</button>
          </div>
        )}
      </div>
    </div>
  );
};

export { DateRangeSelector };
